import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { IFBUserInfo } from '@interfaces';

@Injectable({
  providedIn: 'root'
})
export class AccountResource {
  constructor(private http: HttpClient) {}

  private get url(): string {
    return `https://${environment.API_BASE}/v1/account`;
  }

  public get(token: string) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.get<IFBUserInfo>(this.url, { headers });
  }

  public deleteSelf(token: string, deleteReason?: string) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.post<void>(this.url + '/delete', { deleteReason }, { headers });
  }

  setPassword(userId: string, token: string, body: { password: string }) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    const url = `https://${environment.AUTH_BASE}/api/accounts/${userId}/password`;
    return this.http.put<void>(url, body, { headers });
  }
}
